import { Injectable } from "@angular/core";
import { PictureTag } from "src/app/resources/models/pictureTag";
import { HttpService } from "src/app/session/services/http.service";
import { environment } from "src/environments/environment";

import { Account } from "../models/account";

@Injectable({
  providedIn: "root",
})
export class AccountService {
  constructor(private httpService: HttpService) {}

  public getClientList(): Promise<string[]> {
    return this.httpService
      .get(`${environment.webApiUrl}/api/account/clients`, {
        withCredentials: true,
      })
      .toPromise();
  }

  public getAccounts(): Promise<Account[]> {
    return this.httpService
      .get(`${environment.webApiUrl}/api/account`, { withCredentials: true })
      .toPromise();
  }

  public clientExists(clientId: string, presetName: string): Promise<boolean> {
    return this.httpService
      .get(
        `${environment.webApiUrl}/api/account/ClientExists?clientId=${clientId}&presetName=${presetName}`,
        { withCredentials: true },
      )
      .toPromise();
  }

  public getUserInfo(): Promise<any> {
    return this.httpService
      .get(`${environment.webApiUrl}/api/account/user`, {
        withCredentials: true,
      })
      .toPromise();
  }

  public putForm(formId: string, accountId: string): Promise<void> {
    return this.httpService
      .put(
        `${environment.webApiUrl}/api/account/link-form?formId=${formId}&accountId=${accountId}`,
        { withCredentials: true },
      )
      .toPromise();
  }

  public deleteForm(formId: string, accountId: string): Promise<void> {
    return this.httpService
      .put(
        `${environment.webApiUrl}/api/account/unlink-form?formId=${formId}&accountId=${accountId}`,
        { withCredentials: true },
      )
      .toPromise();
  }

  public putTimeZone(timeZoneInfoId: string, accountId: string): Promise<void> {
    return this.httpService
      .put(
        `${environment.webApiUrl}/api/account/timezone?timeZoneInfoId=${timeZoneInfoId}&accountId=${accountId}`,
        { withCredentials: true },
      )
      .toPromise();
  }

  public putCulture(cultureInfoId: string, accountId: string): Promise<void> {
    return this.httpService
      .put(
        `${environment.webApiUrl}/api/account/culture?cultureInfoId=${cultureInfoId}&accountId=${accountId}`,
        { withCredentials: true },
      )
      .toPromise();
  }

  public createTag(pictureTag: PictureTag): Promise<void> {
    return this.httpService
      .post(`${environment.webApiUrl}/api/account/pictureTag`, pictureTag, {
        withCredentials: true,
      })
      .toPromise();
  }

  public deleteTag(tagId: string): Promise<void> {
    return this.httpService
      .delete(`${environment.webApiUrl}/api/account/pictureTag/${tagId}`, {
        withCredentials: true,
      })
      .toPromise();
  }
}
